import { useTranslation } from 'react-i18next';
import SEO from '@/components/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBar from '@/components/feature/MobileBar';
import { googleMapsLink, address } from '@/mocks/gymInfo';

export default function Localizacao() {
  const { t } = useTranslation();

  const title = t('seo.localizacao.title');
  const description = t('seo.localizacao.description');
  const keywords = t('seo.localizacao.keywords');
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://topgym.com.br';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Place',
    name: 'Top Gym Cumbuco',
    description: description,
    url: `${siteUrl}/localizacao`,
    image: 'https://static.readdy.ai/image/c59ecfd5e54a02b33330323f2bdeb10e/221d8c34c1531330f894539ec6c032ae.jpeg?ogv=l5q6a9',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Av. Central, 2211 - Praia de Cumbuco',
      addressLocality: 'Cumbuco',
      addressRegion: 'CE',
      postalCode: '61619-270',
      addressCountry: 'BR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '-3.6038',
      longitude: '-38.7233',
    },
    telephone: '+55-85-98236-1153',
    '@id': `${siteUrl}/#place`,
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: t('nav.home'),
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: t('page.localizacao.title'),
        item: `${siteUrl}/localizacao`,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEO title={title} description={description} keywords={keywords} path="/localizacao" schema={[schema, breadcrumbSchema]} />
      <Navbar />
      <main className="overflow-x-hidden pb-20 md:pb-0">
        <section className="bg-foreground-950 py-20 md:py-28">
          <div className="w-full px-4 md:px-6">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50">
              {t('page.localizacao.title')}
            </h1>
            <p className="font-body text-base text-background-300 mt-4 max-w-xl">
              {t('page.localizacao.subtitle')}
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
              <div className="flex flex-col justify-center">
                <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200 space-y-6">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center text-accent-500 flex-shrink-0">
                      <i className="ri-map-pin-line text-xl"></i>
                    </div>
                    <div>
                      <p className="font-body text-sm text-foreground-500 mb-1">{t('page.localizacao.addressLabel')}</p>
                      <p className="font-body text-base text-foreground-950 font-medium">{address}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center text-accent-500 flex-shrink-0">
                      <i className="ri-sun-line text-xl"></i>
                    </div>
                    <div>
                      <p className="font-body text-sm text-foreground-500 mb-1">{t('page.localizacao.referenceLabel')}</p>
                      <p className="font-body text-base text-foreground-950">{t('page.localizacao.referenceText')}</p>
                    </div>
                  </div>
                  <a
                    href={googleMapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-foreground-950 hover:bg-foreground-900 text-background-50 font-body text-sm font-semibold px-5 py-2.5 rounded-full transition-colors whitespace-nowrap"
                  >
                    <i className="ri-navigation-line text-base"></i>
                    {t('page.localizacao.openMap')}
                  </a>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden border border-background-200">
                <iframe
                  src="https://maps.google.com/maps?q=Av.+Central,+2211,+Praia+de+Cumbuco,+Caucaia,+CE,+Brazil&output=embed"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Top Gym Cumbuco - Location"
                  className="w-full h-[300px] md:h-[400px]"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}